<div class="load-more-container">
  <app-button
    variant="filled"
    color="primary"
    size="lg"
    [disabled]="isLoading"
    (btnClick)="onLoadMore()">
    <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
    <span *ngIf="!isLoading">{{ 'pages.jobs.common.loadMore' | transloco }} (+{{ remainingCount }})</span>
    <span *ngIf="isLoading">{{ 'pages.jobs.common.loading' | transloco }}</span>
  </app-button>
  <p class="showing-count">
    {{ 'pages.jobs.common.showing' | transloco }} {{ shownItems }} {{ 'pages.jobs.common.of' | transloco }} {{ totalItems }}
  </p>
</div>
